import axios from 'axios';
import router from '../router';
// axios.create({
//     withCredentials: false, // 允许携带cookie
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
//     }
// });
// 请求拦截器
axios.interceptors.request.use(config => {
    if(window.localStorage.getItem('token')) {
        // config.headers['content-type'] = 'Access-Control-Allow-Origin;charset=UTF-8';
        config.headers.Authorization = 'Bearer' + window.localStorage.getItem('token');
    }
    return config;
});
// 响应拦截器
axios.interceptors.response.use(response => {
    if(response.data.status >= 40100) {
        // 40100 token已过期, 40101 token无效, 40102 token被列入黑名单, 40103 未传递token
        window.sessionStorage.clear();
        window.localStorage.clear();
        // 返回登录页重新登录
        router.replace({path: '/login'});
    }
    return response;
});
const apiList = [
    'https://api.bigbays.cn/'
];
const defaultUrl = apiList[0];
export default defaultUrl;


// WEBPACK FOOTER //
// ./src/ws/api.js